<div *ngIf="field.frontendLabel?.toLowerCase() !== 'probability' && field.frontendLabel?.toLowerCase() !== 'sku' && field.frontendLabel?.toLowerCase() !== 'deal name' &&
 field.frontendLabel?.toLowerCase() !== 'weight'
   && field.frontendLabel?.toLowerCase() !== 'city'
    && field.frontendLabel?.toLowerCase() !== 'state'
    && field.frontendLabel?.toLowerCase() !== 'amount'
    && field.frontendLabel?.toLowerCase() !== 'open deal amount'
    && field.frontendLabel?.toLowerCase() !== 'won deals amount'
    && field.frontendLabel?.toLowerCase() !== 'won deal amount'
    && field.frontendLabel?.toLowerCase() !== 'paid'
    && field.frontendLabel!== 'Expected Revenue'
 && field.frontendLabel?.toLowerCase() !== 'phone number'">
  <mat-form-field [attr.guide]="'input-fld-1' + '__' + sanitizeUrl(url)" fxFlex.gt-md="60" fxFlex [formGroup]="group"
    appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>
    <input [autocomplete]="'off'" trim="blur" [required]="field.isRequired == 1" matInput
      [formControlName]="field.attributeCode" />

    <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
      <mat-error *ngIf="group.get(field.attributeCode).hasError(validation.name)">{{validation.message}}</mat-error>
    </div>

  </mat-form-field>
</div>


<div *ngIf="field.frontendLabel=='Probability'">


  <mat-form-field [attr.guide]="'input-fld-2' + '__' + sanitizeUrl(url)" fxFlex.gt-md="60" fxFlex [formGroup]="group"
    appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>

    <input (blur)="getProbability()" [autocomplete]="'off'" [required]="field.isRequired == 1" matInput
      [formControlName]="field.attributeCode" numbersOnly />
    <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
      <mat-error *ngIf="group.get(field.attributeCode).hasError(validation.name)">{{validation.message}}</mat-error>
    </div>
  </mat-form-field>
</div>


<div *ngIf="field.frontendLabel=='City'">


</div>

<div *ngIf="field.frontendLabel=='State'">

</div>


<div *ngIf="field.frontendLabel=='SKU'">

  <mat-form-field [attr.guide]="'input-fld-3' + '__' + sanitizeUrl(url)" fxFlex.gt-md="60" fxFlex [formGroup]="group"
    appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>

    <input [autocomplete]="'off'" [required]="field.isRequired == 1" matInput [formControlName]="field.attributeCode" />
    <mat-error *ngIf="group.get(field.attributeCode).hasError('required')">
      Please fill out this field.
    </mat-error>
    <!-- <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
      <mat-error *ngIf="group.get(field.attributeCode).hasError(validation.name)">{{validation.message}}</mat-error>
    </div> -->
  </mat-form-field>
</div>

<div *ngIf="field.frontendLabel=='Paid'">

  <mat-form-field [attr.guide]="'input-fld-3' + '__' + sanitizeUrl(url)" fxFlex.gt-md="60" fxFlex [formGroup]="group"
    appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>

    <input numbersOnly readonly [autocomplete]="'off'" [required]="field.isRequired == 1" matInput
      [formControlName]="field.attributeCode" />
    <mat-error *ngIf="group.get(field.attributeCode).hasError('required')">
      Please fill out this field.
    </mat-error>
    <!-- <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
      <mat-error *ngIf="group.get(field.attributeCode).hasError(validation.name)">{{validation.message}}</mat-error>
    </div> -->
    <mat-hint>Add Payments For Paid</mat-hint>
  </mat-form-field>

</div>

<div *ngIf="field.frontendLabel=='Expected Revenue'">

  <mat-form-field [attr.guide]="'input-fld-3' + '__' + sanitizeUrl(url)" fxFlex.gt-md="60" fxFlex [formGroup]="group"
    appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>

    <input numbersOnly readonly [autocomplete]="'off'" [required]="field.isRequired == 1" matInput
      [formControlName]="field.attributeCode" />
    <mat-error *ngIf="group.get(field.attributeCode).hasError('required')">
      Please fill out this field.
    </mat-error>
    <!-- <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
      <mat-error *ngIf="group.get(field.attributeCode).hasError(validation.name)">{{validation.message}}</mat-error>
    </div> -->
    <mat-hint>Please Add Amount And Probability For Expected Revenue</mat-hint>
  </mat-form-field>

</div>


<div *ngIf="field.frontendLabel=='Phone Number'">

  <mat-form-field [attr.guide]="'input-fld-4' + '__' + sanitizeUrl(url)" fxFlex.gt-md="60" fxFlex [formGroup]="group"
    appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>
    <input numbersOnly (input)="sanitizeAmount($event)" [autocomplete]="'off'" [required]="field.isRequired == 1"
      matInput [formControlName]="field.attributeCode" />
    <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
      <mat-error *ngIf="group.get(field.attributeCode).hasError(validation.name)">{{validation.message}}</mat-error>
    </div>
  </mat-form-field>
</div>

<div
  *ngIf="field.frontendLabel?.toLowerCase() === 'amount' || field.frontendLabel?.toLowerCase() === 'open deal amount' || field.frontendLabel?.toLowerCase() === 'won deals amount' || field.frontendLabel?.toLowerCase() === 'won deal amount'">

  <mat-form-field [attr.guide]="'input-fld-4' + '__' + sanitizeUrl(url)" fxFlex.gt-md="60" fxFlex [formGroup]="group"
    appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>
    <input numbersOnly (input)="sanitizeAmount($event)" [autocomplete]="'off'" [required]="field.isRequired == 1"
      matInput [formControlName]="field.attributeCode" />
    <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
      <mat-error *ngIf="group.get(field.attributeCode).hasError(validation.name)">
        <ng-container *ngIf="validation.name === 'lessThanPaid'; else defaultMsg">
          Amount cannot be less than the paid amount of {{ group.get('Paid')?.value || group.get('paid')?.value }}.
        </ng-container>
        <ng-template #defaultMsg>
          {{validation.message}}
        </ng-template>
      </mat-error>
    </div>
  </mat-form-field>
</div>

<!-- <div *ngIf="field.frontendLabel=='Phone Number'">

    <mat-form-field [formGroup]="pinform" appearance="outline" fxFlex="10" fxLayoutGap="10px">
      <mat-select formControlName="ampm" (selectionChange)="onSelectionChange($event)">
        <mat-select-trigger>
          <span style="display: inline-flex;" *ngIf="selectedCountry">
            <img [src]="selectedCountry.flag">
            {{ getCountryCode(selectedCountry.name) }}
          </span>
        </mat-select-trigger>

        <mat-option>
          <ngx-mat-select-search placeholderLabel="Search country..."
            [formControl]="searchControl"></ngx-mat-select-search>
        </mat-option>

        <mat-option *ngFor="let country of filteredCountries" [value]="country.id">
          <img [src]="country.flag">&#160; {{country.name}}</mat-option>
      </mat-select>
    </mat-form-field>
    <br>&nbsp;

  <mat-form-field fxFlex.gt-md="50" fxFlex appearance="outline"  [formGroup]="group">
    <mat-label>{{ field.frontendLabel }}</mat-label>
    <input [attr.guide]="'input-inp-5' + '__' + sanitizeUrl(url)" matInput [required]="field.isRequired == 1"
      [formControlName]="field.attributeCode" (input)="updateFullPhoneNumber()"/>
    <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
      <mat-error *ngIf="group.get(field.attributeCode).hasError(validation.name)">{{validation.message}}</mat-error>
    </div>
  </mat-form-field>
</div> -->


<div *ngIf="field.frontendLabel=='Deal Name'">
  <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" fxFlex appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>
    <input [attr.guide]="'input-inp-6' + '__' + sanitizeUrl(url)" type="text" (input)="onInput($event)"
      (blur)="onDealNameBlur()" [required]="field.isRequired == 1" matInput [formControlName]="field.attributeCode"
      [matAutocomplete]="auto1" [readonly]="isOptionSelected" />

    <mat-icon *ngIf="isOptionSelected" matSuffix (click)="clearInputLead()" style="cursor: pointer;">clear</mat-icon>
    <mat-autocomplete #auto1="matAutocomplete">
      <mat-option (onSelectionChange)="onProductSelected($event,option)" *ngFor="let option of productList"
        [value]="option.name">
        {{option.name}}
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="group.controls[field.attributeCode].errors?.required">
      Please fill out this field.
    </mat-error>
  </mat-form-field>
</div>